import React from 'react';
import { ToggleRight } from 'lucide-react';

export interface CustomTogglesStyle01Props {
  toggles: string[];
  values: Record<string, boolean>;
  disabled?: boolean;
  loading?: boolean;
  onChange: (name: string, value: boolean) => void;
  label?: string;
}

// Toggle display translations
const TOGGLE_LABELS: Record<string, string> = {
  AutoDirection: '自動擺動',
  AirClean: '空氣清淨',
  Lock: '鎖定',
  Ionizer: '負離子',
  Swing: '擺動',
  Turbo: '強力模式',
  Eco: '節能模式',
  Sleep: '睡眠模式',
  Light: '燈光',
  Beep: '提示音'
};

/**
 * CustomToggles Style 01 - Switch Grid
 * Command: SetToggles
 * Grid of toggle switches with icons
 */
export const Style01_Switches: React.FC<CustomTogglesStyle01Props> = ({
  toggles,
  values,
  disabled = false,
  loading = false,
  onChange,
  label = '功能開關'
}) => {
  if (!toggles || toggles.length === 0) return null;

  const getToggleLabel = (toggle: string): string => {
    return TOGGLE_LABELS[toggle] || toggle;
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <ToggleRight className="w-4 h-4 text-emerald-400" />
        <span className="text-sm font-medium text-slate-300">{label}</span>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {toggles.map((toggle) => {
          const isOn = values?.[toggle] ?? false;
          return (
            <button
              key={toggle}
              onClick={() => onChange(toggle, !isOn)}
              disabled={disabled || loading}
              className={`px-3 py-2.5 rounded-xl text-xs font-medium transition-all flex items-center justify-between ${
                isOn
                  ? 'bg-emerald-500/20 text-emerald-400 border border-emerald-500/50'
                  : 'bg-slate-700/30 text-slate-400 border border-slate-600/30 hover:bg-slate-600/30'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              <span>{getToggleLabel(toggle)}</span>
              <span className={`w-2 h-2 rounded-full transition-colors ${
                isOn ? 'bg-emerald-400' : 'bg-slate-500'
              }`} />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Style01_Switches;
